import { MRT_ColumnDef, MRT_Row } from "material-react-table";
import { BasicMachineInformationStruct } from "../../../common/Interfaces";
import { Component, useMemo } from "react";
import { AddDocumentState } from "../../../routing/RoutingStates";
import { useNavigate } from "react-router-dom";
import PlusProductNumbers from "../../generic_components/documentTable_components/PlusProductNumber";
import { ISerialNumberColumnsProps } from "../SelectDocumentInterfaces";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileCirclePlus } from "@fortawesome/free-solid-svg-icons";

export default function SerialNumberColumns({
  setPopupContent,
  setShowPopup,
  setPopupTitle,
}: ISerialNumberColumnsProps) {
  const navigate = useNavigate();
  const handleNavigationClick = (row: BasicMachineInformationStruct) => {
    const addDocumentState: AddDocumentState = {
      selectedCompany: {
        key: row.productCompanyCode,
        label: "",
      },
      isProductCompany: true,
      selectedProductRange: row.productRange,
      selectedModels: [row.model],
      productNumbers: row.productNumbers,
      serialNumber: row.serialNumber,
      startDate: null,
      endDate: null,
    };
    navigate("AddDocument", {
      state: { addDocumentState },
    });
  };

  return useMemo<MRT_ColumnDef<BasicMachineInformationStruct>[]>(
    () => [
      {
        accessorKey: "productCompany",
        header: "Product Company",
        muiTableHeadCellProps: {
          sx: {
            flexGrow: 1,
            fontSize: "13px",
          },
          align: "center",
        },
        muiTableBodyCellProps: {
          sx: {
            flexGrow: 1,
            fontSize: "13px",
          },
          align: "center",
        },
        Cell: ({ row }) => {
          return row.original.productCompanyCode;
        },
      },
      {
        accessorKey: "productRange",
        header: "Product Range",
        muiTableHeadCellProps: {
          sx: {
            flexGrow: 1,
            fontSize: "13px",
          },
          align: "center",
        },
        muiTableBodyCellProps: {
          sx: {
            flexGrow: 1,
            fontSize: "13px",
          },
          align: "center",
        },
      },
      {
        accessorKey: "model.key",
        header: "Model",
        muiTableHeadCellProps: {
          sx: {
            flexGrow: 1,
            fontSize: "13px",
          },
          align: "center",
        },
        muiTableBodyCellProps: {
          sx: {
            flexGrow: 1,
            fontSize: "13px",
          },
          align: "center",
        },
      },
      {
        accessorFn: (row) => row.productNumbers?.[0] || "",
        header: "Product Number",
        muiTableHeadCellProps: {
          sx: {
            flexGrow: 1,
            fontSize: "13px",
          },
          align: "center",
        },
        muiTableBodyCellProps: {
          sx: {
            flexGrow: 1,
            fontSize: "13px",
          },
          align: "center",
        },
        Cell: ({ row }: { row: MRT_Row<BasicMachineInformationStruct> }) => (
          <PlusProductNumbers
            productNumbers={row.original.productNumbers}
            setPopupContent={setPopupContent}
            setShowPopup={setShowPopup}
            setPopupTitle={setPopupTitle}
          />
        ),
      },
      {
        accessorKey: "serialNumber",
        header: "Serial Number",
        muiTableHeadCellProps: {
          sx: {
            flexGrow: 1,
            fontSize: "13px",
          },
          align: "center",
        },
        muiTableBodyCellProps: {
          sx: {
            flexGrow: 1,
            fontSize: "13px",
          },
          align: "center",
        },
      },
      {
        id: "actions",
        header: "Actions",
        enableColumnActions: false,
        size: 50,
        muiTableHeadCellProps: {
          sx: {
            flexGrow: 1,
            fontSize: "13px",
          },
          align: "center",
        },
        muiTableBodyCellProps: {
          sx: {
            flexGrow: 1,
            fontSize: "13px",
          },
          align: "center",
        },
        Cell: ({ row }: { row: MRT_Row<BasicMachineInformationStruct> }) => (
          <span style={{ fontSize: "11pt" }}
                title="Add Document" 
                id="mainPageKey"
                onClick={() => handleNavigationClick(row.original)}>
            <FontAwesomeIcon icon={faFileCirclePlus} />
          </span>
        ),
      },
    ],
    []
  );
}
